/**
 * Edgework Sync Layer
 *
 * Progressive model download with resumable transfers.
 */

export { ModelSync } from './model-sync';
export { createModelSync, DEFAULT_SYNC_URLS } from './factory';
export type { SyncOptions } from './factory';
